import Vue from 'vue'
import Vuex from 'vuex'
import {
  isMobile
} from '@/lib/util'
import {mutations, actions} from './@mutations'
import {
  updateURL,
  getStateFromUrl
} from './@util'

Vue.use(Vuex)

const defaults = {
  isMobile: isMobile(),
  isSearch: !!~document.location.href.indexOf('/search'),
  mounted: false,
  sort: '',
  compactView: true,
  showFilterMenu: false,
  showCollectionMenu: false,
  searchQuery: '',
  acceptedFilters: [],
  collection: {
    handle: '',
    image: '',
    title: '',
    description: '',
    fetched: false
  },
  products: [],
  facets: {},
  selectedFacets: [],
  ajaxing: false,
  loading: false,
  currentPage: 1
}

export default () => new Vuex.Store({
  state: Object.assign({},
    defaults,
    getStateFromUrl(Object.keys(defaults))
  ),
  actions,
  mutations,
  plugins: [updateURL]
})
